(() => {
  // app/scripts/ProductCardFetching.js
  !customElements.get("card-fetching") && customElements.define("card-fetching", class productCartForm extends HTMLElement {
    connectedCallback() {
      this.fetch();
    }
    async fetch() {
      let data = await fetch(this.dataset.url);
      data = await data.text();
      const div = document.createElement("div");
      div.innerHTML = data;
      if (div.querySelector(".price").innerHTML == "") {
        this.remove();
        return;
      }
      ;
      this.replaceWith(div.querySelector("product-card"));
    }
  });
})();
